// extracted by mini-css-extract-plugin
export default {"content":"index_content__iqNsK","left":"index_left__W8-8V","icon":"index_icon__6F0uy","right":"index_right__11JYN","arrow":"index_arrow__frzdM"};